import { useVerificationNavigation } from "hooks/useNavigateVerification";
import ArrowRight from "../../assets/ArrowRight.svg";
import LeftIcon from "../../assets/verification/IdColored.svg";
import "./style.scss";
import { useTranslation } from "react-i18next";

const VerificationBanner = () => {
  const { navigateVerification, status } = useVerificationNavigation();
  const { t } = useTranslation("verification");

  if (!status) return <></>;

  return (
    <div
      className="verification-banner-container"
      onClick={navigateVerification}
    >
      <img className="left-icon" src={LeftIcon} alt="icon" />
      <p>{t(String(status))}</p>
      <img className="right-icon" src={ArrowRight} alt="arrow-right" />
    </div>
  );
};

export default VerificationBanner;
